import store from "../store";
import * as types from "./types";

export const openGlobalModal = (modalValue) => ({ type: types.MODAL_OPEN, modalValue });

export const closeGlobalModal = () => ({
  type: types.MODAL_CLOSE
});

export const openChooseCountryModal = (onPressCallback) => {
  store.dispatch({
    type: types.OPEN_CHOOSE_COUNTRY,
    onPressCallback
  });
};

export const closeChooseCountryModal = () => {
  store.dispatch({
    type: types.CLOSE_CHOOSE_COUNTRY,
  });
};
